module.exports = __webpack_public_path__ + "static/gallery_10-0cf673cb5c56ebabe8bdff2511eab4d4.jpg";